<template>
  <div>
    <div class="text-center">
      <v-snackbar
        v-model="error.visible"
        :timeout="6000"
        left
        color="#ff5252"
        >{{ error.message }}</v-snackbar
      >
      <v-snackbar
        v-model="snackbar.visible"
        :timeout="6000"
        left
        color="secondary"
        >{{ snackbar.message }}</v-snackbar
      >
    </div>
    <!-- vuex controlled default alert dialog-->
    <v-row justify="center">
      <v-dialog v-model="universalAlert.visible" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">{{
            universalAlert.heading
          }}</v-card-title>
          <v-card-text>
            <v-alert dense border="left" :type="hinweisTyp">
              {{ universalAlert.text }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="hinweisTyp"
              text
              @click="$store.dispatch('closeUniversalAlert')"
              >{{ $t("alert.altertBack") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["error", "snackbar", "universalAlert"]),
    /**
     * Farbe des Hinweisdialogs.
     *
     * Faellt auf "error" zurueck, wenn der Aufrufer keinen Typ mitgibt. Ohne Typ
     * rendert v-alert farblos und der Knopf stand fest auf "primary" - eine
     * gescheiterte Anmeldung sah damit aus wie ein neutraler Hinweis. Dieser
     * Dialog meldet Probleme; ist nichts anderes angegeben, ist Rot die richtige
     * Annahme. Gleiche Regel wie in util_components/generalVuexHelpers.
     */
    hinweisTyp() {
      return this.universalAlert.type || "error";
    }
  }
};
</script>
